import{a as e}from"./chunk-ZFXP4YRF.js";import{k as o,m as r}from"./chunk-HBP5N4FR.js";r();var c=s=>{let t=o.Buffer.from(s,"base64").toString().split("@");return t.length>=2&&(t[0].length>0?t[0]=e(t[0]):t[1]=e(t[1])),t.join("@")};export{c as a};
//# sourceMappingURL=chunk-MSYI33IZ.js.map
